export default __webpack_public_path__ + "locales/sl/InviteDialog.json?hash=f149d02a2fdc30aa43fe0ac9f83e3f8d";